export const USER_SORT_STRING = 'User';
export const SORT_DIRECTION_ASCENDING = 'asc';
export const SORT_DIRECTION_DESCENDING = 'des';

export const ACTIVITY_REPORT_OUTCOME_SUMMARIES = {
    won: {
        label: 'Activities with sales',
        key: 'won',
        getDataFromStat: (data: any) => data,
        type: 'integer',
    },
    lostOrCancelled: {
        label: 'Activities with losses',
        key: 'lostOrCancelled',
        getDataFromStat: (data: any) => data,
        type: 'integer',
    },
    unknown: {
        label: 'Other activities',
        key: 'unknown',
        getDataFromStat: (data: any) => data,
        type: 'integer',
    },
} as const;
